export enum EntityTypeEnum {
  COMPETITION = "competition",
  TEAM = "team",
  PLAYER = "player",
}
